// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25103
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25103 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
export const PageId = Object.freeze({
  Promotion_Main: 'Promotion_Main'
})

interface IPVTrackParamsRecord {
  /** 促销落地页 */
Promotion_Main: {
/** 促销id  */
promId: string,
/** 渠道名称  */
channelName: string}
}

const sendPv = {
  /** PV-促销落地页 */
Promotion_Main: (page_param: IPVTrackParamsRecord['Promotion_Main']) => {
    eventTrackingUtils.submitPV({page_id:PageId.Promotion_Main,page_param});
  },
}

interface IExpoTrackParamsRecord {
  /** 满足凑单条件进度条拉满时曝光 */
Promotion_ConditionsSatisfaction_Expo: undefined
  /** 搜索框曝光 */
Promotion_SearchBox_Expo: undefined
  /** 排序项曝光 */
Promotion_SortBtn_Expo: {
/** 排序名称  */
sortName: string,
/** 排序状态  */
sortStatus: string}
  /** 筛选按钮曝光 */
Promotion_FilterBtn_Expo: undefined
  /** 筛选浮层曝光 */
Promotion_FilterLayer_Expo: undefined
  /** 搜索-商卡曝光 */
Promotion_Main_Product_Expo: {
/** 关键词  */
keyWord: string,
/** 高相关类目  */
categoryId: string,
/** 搜索请求标识  */
logid: string,
/** 搜索id  */
pvid: string,
/** 实验位信息(搜索)  */
mtest: string,
/** 渠道名称  */
channelName: string,
/** 商品id  */
skuid: string,
/** 位置  */
pos: number,
/** 第一价格金额  */
firprice: number,
/** 第一价格分类 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L4会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,39-xx人拼购价（使用7）,40-x件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,-100-兜底值,0-小时购主要价格,81-直播间价格,82-神价,90-开普勒价,83-原始价,91-试用价,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,85-店铺会员到手价,86-plus会员价,87-渠道价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-未领国补到手价,106-家政0元先享价,107-试算国补价,108-日常价,501-仅微信域红包到手价,109-加价,110-企业拉新,111-入会到手价,112-外卖月卡开卡价 */
firpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '39'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '-100'| '0'| '81'| '82'| '90'| '83'| '91'| '92'| '93'| '94'| '85'| '86'| '87'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108'| '501'| '109'| '110'| '111'| '112',
/** 第二价格金额  */
secprice: number,
/** 第二价格类型 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L5会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,40-X件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金（多阶段支付）,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,80-单规格价格,81-直播间价格,82-神价,83-原始价,90-开普勒价,91-试用价,84-第一件XX元/前n件XX元,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-国补拉新价,106-家政0元先享价,107-试算国补价,108-日常价 */
secpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '80'| '81'| '82'| '83'| '90'| '91'| '84'| '92'| '93'| '94'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108',
/** 置信文案  */
freqTag: string,
/** 优惠券展示文案  */
couponInfo: string,
/** 单品促销  */
single_promotion: string,
/** 总价促销  */
amount_promotion: string,
/** 时效标签  */
time_label: string,
/** 页面内展示的总价促销  */
page_amount_promotion: string,
/** qp归一化后的key  */
NormalizedKey: string,
/** query判断语言类型  */
QPParsedLanguage: string}
  /** 促销说明曝光 */
Promotion_Description_Expo: undefined
  /** 小购物车曝光 */
Promotion_MiniCart_Expo: undefined
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 满足凑单条件进度条拉满时曝光 */
  Promotion_ConditionsSatisfaction_Expo:'Promotion_ConditionsSatisfaction_Expo',
/** 搜索框曝光 */
  Promotion_SearchBox_Expo:'Promotion_SearchBox_Expo',
/** 排序项曝光 */
  Promotion_SortBtn_Expo:'Promotion_SortBtn_Expo',
/** 筛选按钮曝光 */
  Promotion_FilterBtn_Expo:'Promotion_FilterBtn_Expo',
/** 筛选浮层曝光 */
  Promotion_FilterLayer_Expo:'Promotion_FilterLayer_Expo',
/** 搜索-商卡曝光 */
  Promotion_Main_Product_Expo:'Promotion_Main_Product_Expo',
/** 促销说明曝光 */
  Promotion_Description_Expo:'Promotion_Description_Expo',
/** 小购物车曝光 */
  Promotion_MiniCart_Expo:'Promotion_MiniCart_Expo',
})

interface IClickTrackParamsRecord {
  /** 搜索框点击 */
Promotion_SearchBox_Click: undefined
  /** 排序项点击 */
Promotion_SortBtn_Click: {
/** 排序名称  */
sortName: string,
/** 排序状态  */
sortStatus: string}
  /** 筛选按钮点击 */
Promotion_FilterBtn_Click: undefined
  /** 筛选浮层确认按钮点击 */
Promotion_FilterLayer_ConfirmBtn_Click: undefined
  /** 搜索-商卡点击 */
Promotion_Main_Product: {
/** 关键词  */
keyWord: string,
/** 高相关类目  */
categoryId: string,
/** 搜索请求标识  */
logid: string,
/** 搜索id  */
pvid: string,
/** 实验位信息(搜索)  */
mtest: string,
/** 渠道名称  */
channelName: string,
/** 商品id  */
skuid: string,
/** 位置  */
pos: number,
/** 第一价格金额  */
firprice: number,
/** 第一价格分类 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L4会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,39-xx人拼购价（使用7）,40-x件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,-100-兜底值,0-小时购主要价格,81-直播间价格,82-神价,90-开普勒价,83-原始价,91-试用价,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,85-店铺会员到手价,86-plus会员价,87-渠道价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-未领国补到手价,106-家政0元先享价,107-试算国补价,108-日常价,501-仅微信域红包到手价,109-加价,110-企业拉新,111-入会到手价,112-外卖月卡开卡价 */
firpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '39'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '-100'| '0'| '81'| '82'| '90'| '83'| '91'| '92'| '93'| '94'| '85'| '86'| '87'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108'| '501'| '109'| '110'| '111'| '112',
/** 第二价格金额  */
secprice: number,
/** 第二价格类型 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L5会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,40-X件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金（多阶段支付）,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,80-单规格价格,81-直播间价格,82-神价,83-原始价,90-开普勒价,91-试用价,84-第一件XX元/前n件XX元,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-国补拉新价,106-家政0元先享价,107-试算国补价,108-日常价 */
secpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '80'| '81'| '82'| '83'| '90'| '91'| '84'| '92'| '93'| '94'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108',
/** 置信文案  */
freqTag: string,
/** 优惠券展示文案  */
couponInfo: string,
/** 单品促销  */
single_promotion: string,
/** 总价促销  */
amount_promotion: string,
/** 时效标签  */
time_label: string,
/** 页面内展示的总价促销  */
page_amount_promotion: string,
/** query判断语言类型  */
QPParsedLanguage: string,
/** qp归一化后的key  */
NormalizedKey: string}
  /** 搜索-商卡加购 */
Promotion_Main_Product_AddtoCart: {
/** 关键词  */
keyWord: string,
/** 高相关类目  */
categoryId: string,
/** 搜索请求标识  */
logid: string,
/** 搜索id  */
pvid: string,
/** 实验位信息(搜索)  */
mtest: string,
/** 渠道名称  */
channelName: string,
/** 商品id  */
skuid: string,
/** 位置  */
pos: number,
/** 第一价格金额  */
firprice: number,
/** 第一价格分类 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L4会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,39-xx人拼购价（使用7）,40-x件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,-100-兜底值,0-小时购主要价格,81-直播间价格,82-神价,90-开普勒价,83-原始价,91-试用价,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,85-店铺会员到手价,86-plus会员价,87-渠道价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-未领国补到手价,106-家政0元先享价,107-试算国补价,108-日常价,501-仅微信域红包到手价,109-加价,110-企业拉新,111-入会到手价,112-外卖月卡开卡价 */
firpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '39'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '-100'| '0'| '81'| '82'| '90'| '83'| '91'| '92'| '93'| '94'| '85'| '86'| '87'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108'| '501'| '109'| '110'| '111'| '112',
/** 第二价格金额  */
secprice: number,
/** 第二价格类型 1-新人价,2-重逢价,3-粉丝价,4-闪购价,5-学生价,6-企业价,7-拼购价,8-家庭价,9-plus价,10-合约价,11-到手价,12-店铺会员价-L1会员,13-店铺会员价-L2会员,14-店铺会员价-L3会员,15-店铺会员价-L4会员,16-店铺会员价-L5会员,17-1号店会员价,18-电子书价,19-sam价,20-门店价,21-进口新客价,22-企业新人价,23-专属价,24-首单新人价,26-秒杀价,27-秒杀专享价,28-城市专享价,29-临期特卖,30-商场同款,31-商品定制价,32-亲子价,33-超市新人价,34-预售价,35-EDLP,36-砍后价,37-拼团价,38-陪伴价,40-X件单价约xx,41-xx件单价,42-天天低价,43-低于30天均价,44-京东价,45-企业会员价,46-补贴价,47-套装价,48-区间价,49-百补补贴价,50-百补日常价,51-租赁价,52-划线价,53-拍卖当前价,54-起拍价,73-定期购预估总价,74-订金（多阶段支付）,75-区域专享价,76-星巴克会员价,77-医药商品单盒价,78-内购价,79-小时达新人到手价,80-单规格价格,81-直播间价格,82-神价,83-原始价,90-开普勒价,91-试用价,84-第一件XX元/前n件XX元,92-百补多人团价,93-秒送兑换券价（0元）,94-预售券后价,95-单促价,96-儿童价,97-婴儿价,98-火车票价格,99-直播专享价,100-直播专享价到手价,101-直播专享券到手价,102-预估新人价,103-未登录到手价,104-国补到手价,105-国补拉新价,106-家政0元先享价,107-试算国补价,108-日常价 */
secpricetype: | '1'| '2'| '3'| '4'| '5'| '6'| '7'| '8'| '9'| '10'| '11'| '12'| '13'| '14'| '15'| '16'| '17'| '18'| '19'| '20'| '21'| '22'| '23'| '24'| '26'| '27'| '28'| '29'| '30'| '31'| '32'| '33'| '34'| '35'| '36'| '37'| '38'| '40'| '41'| '42'| '43'| '44'| '45'| '46'| '47'| '48'| '49'| '50'| '51'| '52'| '53'| '54'| '73'| '74'| '75'| '76'| '77'| '78'| '79'| '80'| '81'| '82'| '83'| '90'| '91'| '84'| '92'| '93'| '94'| '95'| '96'| '97'| '98'| '99'| '100'| '101'| '102'| '103'| '104'| '105'| '106'| '107'| '108',
/** 置信文案  */
freqTag: string,
/** 优惠券展示文案  */
couponInfo: string,
/** 单品促销  */
single_promotion: string,
/** 总价促销  */
amount_promotion: string,
/** 时效标签  */
time_label: string,
/** 页面内展示的总价促销  */
page_amount_promotion: string}
  /** 促销terms点击 */
Promotion_Terms_Click: undefined
  /** 配送方式点击 */
Promotion_Delivery_Click: undefined
  /** 自提方式点击 */
Promotion_Pickup_Click: undefined
  /** 小购物车点击 */
Promotion_MiniCart_Click: undefined
  /** 加购商品卡片曝光 */
Promotion_ProductCard_Expo: undefined
}

const sendClickTrack = {
  /** 点击事件上报-搜索框点击 */
Promotion_SearchBox_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Promotion_SearchBox_Click'});
  },
  /** 点击事件上报-排序项点击 */
Promotion_SortBtn_Click: (json_param: IClickTrackParamsRecord['Promotion_SortBtn_Click']) => {
    eventTrackingUtils.submitCL({event_id:'Promotion_SortBtn_Click',json_param});
  },
  /** 点击事件上报-筛选按钮点击 */
Promotion_FilterBtn_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Promotion_FilterBtn_Click'});
  },
  /** 点击事件上报-筛选浮层确认按钮点击 */
Promotion_FilterLayer_ConfirmBtn_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Promotion_FilterLayer_ConfirmBtn_Click'});
  },
  /** 点击事件上报-搜索-商卡点击 */
Promotion_Main_Product: (json_param: IClickTrackParamsRecord['Promotion_Main_Product']) => {
    eventTrackingUtils.submitCL({event_id:'Promotion_Main_Product',json_param});
  },
  /** 点击事件上报-搜索-商卡加购 */
Promotion_Main_Product_AddtoCart: (json_param: IClickTrackParamsRecord['Promotion_Main_Product_AddtoCart']) => {
    eventTrackingUtils.submitCL({event_id:'Promotion_Main_Product_AddtoCart',json_param});
  },
  /** 点击事件上报-促销terms点击 */
Promotion_Terms_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Promotion_Terms_Click'});
  },
  /** 点击事件上报-配送方式点击 */
Promotion_Delivery_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Promotion_Delivery_Click'});
  },
  /** 点击事件上报-自提方式点击 */
Promotion_Pickup_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Promotion_Pickup_Click'});
  },
  /** 点击事件上报-小购物车点击 */
Promotion_MiniCart_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Promotion_MiniCart_Click'});
  },
  /** 点击事件上报-加购商品卡片曝光 */
Promotion_ProductCard_Expo: () => {
    eventTrackingUtils.submitCL({event_id:'Promotion_ProductCard_Expo'});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}